import { faBagShopping } from "@jewlr/pro-light-svg-icons/faBagShopping"
import PropTypes from "prop-types"
import { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { fetchCartList } from "app-store-v2/app/actions"
import NavIcon from "areas/header/nav-icon"

const CartIcon = ({
  cartLoaded,
  count,
  fetchCartList,
  isMobile,
  onNavClick,
}) => {
  const previousCart = useRef({ cartLoaded, count })
  const [announcement, setAnnouncement] = useState("")
  const cartLabel = cartLoaded
    ? `Cart, ${count || 0} ${count === 1 ? "item" : "items"}`
    : "Cart"

  useEffect(() => {
    const previous = previousCart.current
    if (!cartLoaded) {
      setAnnouncement("")
    } else if (!previous.cartLoaded || previous.count !== count) {
      setAnnouncement(cartLabel)
    }
    previousCart.current = { cartLoaded, count }
  }, [cartLoaded, count, cartLabel])

  useEffect(() => {
    fetchCartList()
  }, [])

  return (
    <>
      <Link
        aria-label={cartLabel}
        className="relative inline-block"
        data-cy={`header-cart-icon-${isMobile ? "mobile" : "desktop"}`}
        data-lc="cart-icon"
        onClick={onNavClick}
        to="/cart"
      >
        <NavIcon icon={faBagShopping} />
        {cartLoaded && count > 0 && (
          <div
            aria-hidden="true"
            className="bg-link text-10 size-15 absolute -right-8 -top-6 flex items-center justify-center rounded-full text-center text-white"
          >
            {count}
          </div>
        )}
      </Link>
      <div
        aria-atomic="true"
        aria-live="polite"
        className="sr-only"
        role="status"
      >
        {announcement}
      </div>
    </>
  )
}

CartIcon.propTypes = {
  cartLoaded: PropTypes.bool,
  count: PropTypes.number,
  fetchCartList: PropTypes.func,
  isMobile: PropTypes.bool,
  onNavClick: PropTypes.func,
}

const mapStateToProps = (state) => ({
  cartLoaded: state.cart.cartLoaded,
  count: state.cart.count,
})

const mapDispatchToProps = (dispatch) => ({
  fetchCartList: () => dispatch(fetchCartList()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CartIcon)
